import script from "./KBillButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./KBillButton.vue?vue&type=script&setup=true&lang=ts"

import "./KBillButton.vue?vue&type=style&index=0&id=088c8c1a&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-088c8c1a"]])

export default __exports__